import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getMilestones,
  setSelectedMileTask,
  toggleMilestone,
} from "../../features/milestonesSlice";
import { ChevronDown, ChevronRight, Edit } from "lucide-react";
import { getUsers } from "../../features/usersSlice";
import Modal from "../../components/modal/Modal";
import { openModal } from "../../features/modalSLice";
import ProjectTaskDetails from "./ProjectTaskDetails";
import Loading from "../../components/loading/Loading";
import loadStatus from "../../util/loadStatus";
import NetworkError from "../error/NetworkError";
import { useLocation } from "react-router-dom";

const ProjectTasks = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const milestones = useSelector((state) => state.milestones.data);
  const projectId = useSelector((state) => state.projects.selected.id);
  const modalContent = useSelector((state) => state.modal.content);
  const { loading, error } = useSelector((state) => state.milestones);

  const handleDetailClicked = (e, task) => {
    e.preventDefault();
    if (task.id) {
      dispatch(setSelectedMileTask(task));
    }
    dispatch(openModal(<ProjectTaskDetails />));
  };

  useEffect(() => {
    dispatch(getMilestones(projectId));
    dispatch(getUsers());
  }, []);

  if (loading === loadStatus.loading) {
    <Loading />;
  }

  if (loading === loadStatus.error) {
    <NetworkError to={location.pathname} />;
  }

  if (loading === false && error !== null) {
    return <div>Error: {error.message}</div>;
  }

  return (
    <div>
      <Modal children={modalContent}></Modal>
      <h3 className="mb-4 text-text-1/80">Milestones</h3>
      <div className="w-full hidden md:block overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-20">
          <thead className="bg-content">
            <tr className="text-nowrap">
              <th className="w-1/12 p-2 bg-bkg2 text-text-1/80 rounded-l-md">
                #
              </th>
              <th className="w-4/12 p-2 bg-bkg2 text-text-1/80">Task Name</th>
              <th className="w-2/12 p-2 bg-bkg2 text-text-1/80 text-center">
                Status
              </th>
              <th className="w-1/12 p-2 bg-bkg2 text-text-1/80 text-center">
                Hours
              </th>
              <th className="w-2/12 p-2 bg-bkg2 text-text-1/80 text-center">
                Task Assign
              </th>
              <th className="w-2/12 p-2 bg-bkg2 text-text-1/80">Due Date</th>
              <th className="w-1/12 p-2 bg-bkg2 text-text-1/80 rounded-r-md">
                Actions
              </th>
            </tr>
          </thead>
          <tbody className="divide-y ">
            {milestones.map((milestone, index) => (
              <React.Fragment key={milestone.id}>
                <tr
                  className="bg-content cursor-pointer border-none"
                  onClick={() => dispatch(toggleMilestone(milestone.id))}
                >
                  <td colSpan="7" className="bg-content ">
                    <div className="flex justify-start items-center py-2 px-1 gap-3 bg-primary/80 rounded-md mb-3 mt-1 ">
                      <button className="p-0.5 bg-gray-200 text-gray-700 rounded-md">
                        {milestone.isOpen ? <ChevronDown /> : <ChevronRight />}
                      </button>
                      <span className="text-gray-200">{milestone.name}</span>
                    </div>
                  </td>
                </tr>
                {milestone.isOpen &&
                  milestone.tasks.map((task, taskIndex) => (
                    <tr
                      key={task.id}
                      className="bg-bkg border-none text-text-1/90"
                    >
                      <td className="border-none p-2 pl-6 rounded-l-md ">
                        {taskIndex + 1}
                      </td>
                      <td className="border-none p-2 text-left">{task.name}</td>
                      <td className="border-none p-2 ">
                        <span
                          className={`text-center text-sm px-2 py-0.5 rounded inline-block font-bold  text-text-white`}
                          style={{ backgroundColor: task.color }}
                        >
                          {task.status}
                        </span>
                      </td>
                      <td className="border-none p-2 text-center">
                        {task.start_date}
                      </td>
                      <td className="border-none p-2 text-center">
                        {task
                          ? task.user?.last_name[0] +
                            ". " +
                            task.user?.first_name
                          : "---"}
                      </td>
                      <td className="border-none p-2">{task.end_date}</td>
                      <td className="border-none p-2 rounded-r-md">
                        {task.status === "Active" && (
                          <button
                            onClick={(e) => handleDetailClicked(e, task)}
                            disabled={
                              task.status === "Completed" ? true : false
                            }
                          >
                            <Edit className="text-text-1/75 cursor-pointer" />
                          </button>
                        )}
                      </td>
                    </tr>
                  ))}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>

      <div className="block md:hidden">
        {milestones.map((milestone) => (
          <div key={milestone.id} className="mb-4">
            <div
              className="flex justify-start items-center cursor-pointer gap-4 bg-primary/80 py-2 px-1 rounded-md"
              onClick={() => dispatch(toggleMilestone(milestone.id))}
            >
              <button className="p-0.5 bg-gray-200 text-gray-700 rounded-md">
                {milestone.isOpen ? <ChevronDown /> : <ChevronRight />}
              </button>
              <span className="text-gray-200">{milestone.name}</span>
            </div>
            {milestone.isOpen &&
              milestone.tasks.map((task, index) => (
                <div key={task.id} className="bg-white p-4 mb-4 rounded shadow">
                  <div className="flex justify-between items-center">
                    <div>
                      <span className="font-bold">{index + 1}.</span>
                      <span className="ml-2">{task.name}</span>
                    </div>
                    <Edit className="text-text-1/75 cursor-pointer" />
                  </div>
                  <div className="mt-2">
                    <span className="block">Status: {task.status}</span>
                    <span className="block">Hours: {task.hours}</span>
                    <span className="block">Assigned to: {task.assign}</span>
                    <span className="block">Due: {task.dueDate}</span>
                  </div>
                </div>
              ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProjectTasks;
